import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = {
    platform: {
      title: '平台功能',
      links: [
        { label: '企业官网搭建', path: '/category/qiyewangzhan' },
        { label: '个人博客搭建', path: '/category/gerenblog' },
        { label: '电商网站搭建', path: '/category/dianshang' },
        { label: '餐饮网站搭建', path: '/category/canYin' },
        { label: '教育培训建站', path: '/category/jiaoyu' },
      ],
    },
    resources: {
      title: '建站资源',
      links: [
        { label: '建站教程', path: '/category/jianzhanjiaocheng' },
        { label: 'SEO优化指南', path: '/article/seo-youhua-jiqiao' },
        { label: '平台对比', path: '/article/mianfei-jianzhan-pingtai-duibi' },
        { label: '企业建站指南', path: '/article/qiyewangzhan-jianzhan-zhinan' },
        { label: '全部模板', path: '/category/all' },
      ],
    },
    about: {
      title: '关于我们',
      links: [
        { label: '品牌故事', path: '/about' },
        { label: '用户口碑', path: '/about' },
        { label: '联系我们', path: '/about' },
      ],
    },
  };

  return (
    <footer className="bg-secondary-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-global-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-foreground-950 font-heading">
                免费建站
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-5">
              零成本快速建站平台，无需编程，一键生成专业网站。服务超过50万用户，让每个人都能轻松拥有自己的网站。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50 flex items-center justify-center text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="邮箱">
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4 font-heading">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 免费在线成网站平台. 保留所有权利.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}